module.exports = __webpack_public_path__ + "static/media/volcano.faf20203.svg";